import Angular from "angular";
import Loader from "angular-ecmascript/module-loader";
import {Service} from "angular-ecmascript/module-helpers";

export class ViewService extends Service {
    static $name = "$viewService";
    static $inject = ['$state'];

    create() {
        // NOOP.
    }

    toView(targetView, options) {
        var targetState = null;
        var states = this.$state.get();

        for (var i = 0; i < states.length; ++i) {
            var state = states[i];
            if (!state.views) {
                continue;
            }

            for (let [key, view] of Object.entries(state.views)) {
                if (view == targetView) {
                    targetState = state;
                    break;
                }
            }

            if (targetState) {
                break;
            }
        }

        if (targetState) {
            this.$state.go(targetState.name, options);
        }
    }
}

var ViewServiceModule = Angular.module('service.view', []);

new Loader(ViewServiceModule)
    .load(ViewService);

export default ViewServiceModule;



// WEBPACK FOOTER //
// ./src/modules/core/views/view.service.js